import _ from "lodash";
import React from "react";
import { CheckTreePicker as RSuiteCheckTreePicker } from "rsuite";
import axios from "../../utilities/axios";

export class CheckTreePicker extends React.Component<any, {}> {
  public state = {
    preloadedData: [],
    data: this.props.data ?? [],
    inputValue: "",
    loading: true,
    value: this.props.value ?? null,
  };

  componentDidMount() {
    this.handleUpdate();
  }

  componentDidUpdate(props: any) {}

  find(text: any, array: any): any {
    var result = array.filter((item: any) => {
      if (
        item["label"] &&
        item["label"].toLocaleLowerCase().includes(text.toLocaleLowerCase())
      ) {
        if (item["children"]) {
          return this.find(text, item["children"]).length > 0;
        } else {
          return true;
        }
      }
      return false;
    });

    return result;
  }

  handleUpdate = (value: any = null) => {
    if (this.props.api) {
      this.setState({ loading: true });
      axios
        .get(this.props.api.url, {
          params: {
            ...this.props.uses,
            search: value,
            concat: this.props.displayLabel,
            CheckTreePicker: true,
          },
        })
        .then((res) => {
          var arr: any = [...res.data.items];

          if (this.state.preloadedData) {
            arr = _.uniqBy([...this.state.preloadedData, ...arr], "value");
          }
          if (value) {
            arr = this.find(value, arr);
          }

          this.setState({ data: arr, loading: false });
        })
        .catch((e) => {
          this.setState({ loading: false });
        })
        .finally(() => {});
    } else {
      setTimeout(() => {}, 100);
    }
  };

  onChange = (incomingValue: any) => {
    var value = _.uniq(incomingValue);
    if (this.props.onChange) {
      this.props.onChange(value, this.state.data);
    }
    this.setState({ value });
  };

  onSearch = (value: any) => {
    alert(value);
  };

  public timeout: any = null;
  onChangeInput = (value: string) => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.handleUpdate(value);
    }, 600);
  };

  shouldComponentUpdate(props: any, state: any) {
    if (this.state.inputValue !== state.inputValue) {
      return false;
    }
    return true;
  }

  render() {
    return (
      <>
        <RSuiteCheckTreePicker
          style={this.props.style}
          placeholder={"Selecione..."}
          preventOverflow
          virtualized
          cascade={true}
          onChange={this.onChange}
          onOpen={this.handleUpdate}
          value={this.state.value}
          data={this.state.data}
          disabled={this.props.disabled}
          labelProps={
            this.props.displayLabel !== undefined &&
            this.props.displayLabel !== ""
              ? this.props.displayLabel
              : undefined
          }
        />
        {}
      </>
    );
  }
}
